import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Image } from 'antd'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { StyledCarousel } from './styles'

export default function MenuCarousel ({ contents }) {
  const router = useRouter()

  const carouselSettings = {
    speed: 500,
    dots: true,
    infinite: true,
    arrows: true,
    mobileFirst: true,
    centerMode: true,
    nextArrow: <RightOutlined />,
    prevArrow: <LeftOutlined />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          swipeToSlide: true,
          dots: false,
          arrows: false
        }
      }
    ]
  }

  return (
    <>
      {typeof contents !== 'undefined' && contents.length > 0 && (
        <StyledCarousel {...carouselSettings}>
          {contents.map((content) => (
            <Image
              key={content.id}
              src={content.web_banner}
              preview={false}
              onClick={() =>
                router.push(`/promos/${content.details[0].product_code}`)
              }
            />
          ))}
        </StyledCarousel>
      )}
    </>
  )
}

MenuCarousel.propTypes = {
  contents: PropTypes.array
}
